import { useMutation } from "@tanstack/react-query";
import { getCatalog, getAnatomies } from "../mutations/getCatalog";
export const useCatalog = () => {
  const mutation = useMutation({
    mutationFn: (catalogType) => getCatalog(catalogType),
  });

  const anatomiesMutation = useMutation({
    mutationFn: () => getAnatomies(),
  });

  return {
    getCatalog: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    error: mutation.error,
    getAnatomies: anatomiesMutation.mutateAsync,
    isAnatomiesLoading: anatomiesMutation.isLoading,
    anatomiesError: anatomiesMutation.error,
  };
};
